import { Button, Drawer, Form, Input, notification, Popover, Select } from 'antd';
import React, { FC, useState } from 'react';
import { useForm } from 'antd/lib/form/Form';
import { useCreateFaqCategoryMutation } from 'app/services/edpApiV1/faq';
import { TFaqCategoryCreateRequest } from 'shared/types/faq.types';
import { returnErrorOrMessage } from 'shared/helpers/errors';
import { SimpleIconName, resolveGlyph } from '../../../shared/components/icons/icons';
import style from './index.module.scss';
import ListOfIcons from './listOfIcons/ListOfIcons';

type TProps = {
  onClose: () => void;
  open: boolean;
};

const CreateCategoryDrawer: FC<TProps> = ({ onClose, open }) => {
  const [form] = useForm();
  const [openPopover, setOpenPopover] = useState<boolean>(false);
  const [currentIcon, setCurrentIcon] = useState<SimpleIconName | undefined>();
  const [createFaq, { isLoading }] = useCreateFaqCategoryMutation();
  const [val, setVal] = useState<boolean>(false);

  const onCloseClick = () => {
    onClose();
  };

  const onSubmit = () => {
    form.submit();
  };

  const onFinish = async (data: TFaqCategoryCreateRequest) => {
    try {
      await createFaq({ icon: currentIcon!, name: data.name });
      notification.success({ message: 'Категория создана' });
      form.resetFields();
      onClose();
    } catch (e: any) {
      notification.error({ message: returnErrorOrMessage(e, 'Что-то пошло не так') });
    }
  };

  const handleOpenChange = () => {
    setOpenPopover(prev => !prev);
  };

  const onIconClick = (icon: SimpleIconName) => {
    setCurrentIcon(icon);
    setOpenPopover(false);
  };

  return (
    <Drawer
      title="Добавление категории"
      onClose={onClose}
      open={open}
      width={720}
      extra={
        <div className={style['action-btns']}>
          <Button onClick={onCloseClick}>Отмена</Button>
          <Button
            onClick={onSubmit}
            loading={isLoading}
            type="primary"
            disabled={!form.getFieldValue('name') || !currentIcon}
          >
            Ок
          </Button>
        </div>
      }
    >
      <Form layout="vertical" form={form} onFinish={onFinish}>
        <Form.Item label="Наименование категории" name="name" required>
          <Input placeholder="Введите наименование" onChange={() => setVal(prev => !prev)} />
        </Form.Item>
        <Form.Item label="Иконка" name="icon" required>
          <Popover
            content={<ListOfIcons onClick={onIconClick} />}
            title="Иконки"
            placement="topRight"
            trigger="click"
            open={openPopover}
            onOpenChange={handleOpenChange}
          >
            <div className={style['icon-select']}>
              <Select
                style={{ width: 70 }}
                className="icon-select-elem"
                value={currentIcon ? resolveGlyph(currentIcon) : undefined}
                // currentIcon ? <SimpleIcon name={currentIcon} /> : undefined}
                dropdownStyle={{ display: 'none' }}
              />
            </div>
          </Popover>
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default CreateCategoryDrawer;
